import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import ls from 'localstorage-slim';
import { Observable, Subject } from 'rxjs';
import { map, skipWhile, takeUntil, tap } from 'rxjs/operators';
import { ModalContent } from 'src/app/models/modal-content.model';
import {
  HomeViewModel,
  selectHomeViewModel
} from 'src/app/store/selectors/home/home.selectors';
import { environment } from 'src/environments/environment';
import { SUPER_USER } from '../../../app.constants';
import { ProfileImage } from '../../../models/profile-image.model';
import { scaleIn400ms } from '../../../shared/utils/animations/scale-in.animation';
import { initials } from '../../../shared/utils/initials.utils';
import { AppState } from '../../../store';
import * as fromCRMActions from '../../../store/actions/crm/crm.actions';
import * as fromDashboardActions from '../../../store/actions/dashboard/dashboard.actions';
import * as fromCrmSelectors from '../../../store/selectors/crm/crm.selectors';
import * as fromOrdersSelectors from '../../../store/selectors/orders/orders.selectors';
import { selectProfileImage } from '../../../store/selectors/profile/profile.selectors';
import { PermissionService } from '../../auth/services/permission.service';
import { mainNavigation } from '../main-navigation';

ls.config.encrypt = true;

@Component({
  selector: 'lns-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  animations: [scaleIn400ms]
})
export class LayoutComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  clientDetails$: Observable<fromOrdersSelectors.OrdersUserModel>;
  navigationItems = mainNavigation;
  client: string | null = '';
  profileInitials: string | null = null;
  exchangeModalOpened = false;
  locationModalOpened = false;
  environment = environment;
  savings: any = [];
  deposits: any = [];
  loans: any = [];
  cards: any = [];
  profileImage$: Observable<ProfileImage>;
  crmData$: Observable<fromCrmSelectors.CrmModel>;
  countMessages$: Observable<number>;

  exchangeContent: ModalContent = {
    title: 'more_option_external_link_title',
    content: 'more_option_external_link_text',
    buttons: []
  };

  locationContent: ModalContent = {
    title: 'more_options_locations',
    content: 'more_option_external_link_location_text',
    buttons: []
  };
  superUser: any;

  constructor(
    private store: Store<AppState>,
    private permissionService: PermissionService
  ) {
    this.profileImage$ = this.store.select(selectProfileImage);
    this.crmData$ = this.store.pipe(select(fromCrmSelectors.selectCRMOffers));
    this.clientDetails$ = this.store.select(fromOrdersSelectors.selectUserData);
    this.countMessages$ = this.store.select(
      fromCrmSelectors.selectCountMessages
    );
  }

  ngOnInit(): void {
    this.getSuperUser();
    this.store.dispatch(fromDashboardActions.loadDashboardApi());
    this.store.dispatch(fromDashboardActions.loadProfileImageApi());
    this.store.dispatch(fromDashboardActions.loadUserDetailsApi());
    this.store.dispatch(fromCRMActions.countCRMOffersApi());
    this.loadClientData();
    this.loadAccounts();
  }

  private loadClientData(): void {
    this.clientDetails$
      .pipe(
        tap(userData => {
          if (userData.userDetails) {
            this.client = userData.userDetails.linkedClients[0].name;
            this.profileInitials = initials(this.client);
          }
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();
  }

  openExchangeModal(): void {
    this.exchangeModalOpened = !this.exchangeModalOpened;
  }

  openLocationModal(): void {
    this.locationModalOpened = !this.locationModalOpened;
  }

  hasAppPermission(permission: string): boolean {
    return this.permissionService.hasPermission(permission);
  }

  crmBgColor() {
    return document.location.href.includes('/crm');
  }

  loadAccounts() {
    this.store.dispatch(fromDashboardActions.refreshDashboardApi());
    this.store
      .pipe(
        select(selectHomeViewModel),
        skipWhile(value => value.accounts === null),
        map((homeViewModel: HomeViewModel) => {
          return {
            accounts: homeViewModel.accounts,
            savings: homeViewModel.savings,
            deposits: homeViewModel.deposits,
            loans: homeViewModel.loans,
            cards: homeViewModel.cards
          };
        })
      )
      .subscribe(allAccounts => {
        this.loans = allAccounts.loans;
        this.savings = allAccounts.savings;
        (this.deposits = allAccounts.deposits),
          (this.cards = allAccounts.cards);
      });
  }

  getSuperUser(): void {
    this.superUser = ls.get(SUPER_USER);
  }

  /* Check cards on layout*/
  checkIfLinkVisible(nav: any) {
    if (
      (nav.name === 'more_options_savings' && !this.savings?.length) ||
      (nav.name === 'more_options_deposits' && !this.deposits?.length) ||
      (nav.name === 'more_options_credit' && !this.loans?.length) ||
      (nav.name === 'menu_cards' && !this.cards?.length) ||
      (nav.name === 'ibSpecific.orders.title' && this.superUser)
    ) {
      return false;
    } else return true;
  }
}
